import * as React from 'react';
import { MultiColorRow } from '../components/MultiColorRow';
import {
  FrameSettingsPopover,
  FrameSettingsPopoverProps
} from './FrameSettingsPopover';
import { CustomPropertyRow } from 'controller/CustomPropertyRow';
import { CustomProperty } from 'data/CustomProperty';
import { PropertyType } from '@beatflyer/shaders-lib';

interface Props extends FrameSettingsPopoverProps {
  colors: string[];
  rotation: number;
  onChange: (colors: string[]) => void;
  onRotationChange: (angle: number) => void;
}

export const GradientSettingsPopover: React.FC<Props> = ({
  colors,
  rotation,
  onChange,
  trigger,
  onClose,
  onRotationChange
}) => {
  const addColor = React.useCallback(() => {
    const lastColor = colors[colors.length - 1];
    onChange(colors.concat([lastColor]));
  }, [colors, onChange]);

  const removeColor = React.useCallback(
    (index: number) => {
      const newColors = colors.concat([]);
      newColors.splice(index, 1);
      onChange(newColors);
    },
    [colors, onChange]
  );

  const colorDidChange = React.useCallback(
    (index: number, color: string) => {
      const newColors = colors.concat([]);
      newColors.splice(index, 1, color);
      onChange(newColors);
    },
    [colors, onChange]
  );

  const rotationDidChange = React.useCallback(
    (_property: string, value: number) => {
      onRotationChange(value);
    },
    [onRotationChange]
  );

  const rotationProperty: CustomProperty = {
    name: 'Rotation',
    type: PropertyType.DIRECTION,
    value: rotation
  };

  console.log('RENDER', rotation);

  return (
    <FrameSettingsPopover
      className="gradient-settings-popover"
      trigger={trigger}
      onClose={onClose}
    >
      <MultiColorRow
        color={colors}
        onChange={colorDidChange}
        addColor={addColor}
        removeColor={removeColor}
        compact={false}
      />
      <CustomPropertyRow
        name="Rotation"
        id="rotation"
        value={rotationProperty.value}
        data={rotationProperty}
        onChange={rotationDidChange}
      />
    </FrameSettingsPopover>
  );
};



// WEBPACK FOOTER //
// ./src/controller/settings-popovers/GradientSettingsPopover.tsx